import { Box, Grid } from "@mui/material";
import React, { useMemo } from "react";

import { type AccountQualityEnum, type TicketHeadingCategoryEnum } from "src/graphql/generated/types";
import { getTicketHeadingCategoryOptions } from "src/utils";
import { isActivationKey } from "src/utils/activationKey";

import { CategoryCard } from "../CategoryCard";

type Props = {
  quality: AccountQualityEnum;
  selectedHeadingCategory: TicketHeadingCategoryEnum | "";
  setSelectedHeadingCategory: (value: TicketHeadingCategoryEnum) => void;
  disabled?: boolean;
};

export const CategoriesGrid = ({
  quality,
  selectedHeadingCategory,
  setSelectedHeadingCategory,
  disabled,
}: Props) => {
  const ticketCategories = useMemo(() => getTicketHeadingCategoryOptions(quality), []);

  return (
    <Box sx={{ mx: 2 }}>
      <Grid container spacing={3}>
        {ticketCategories.map((card, index) => {
          const isSelected = ticketCategories[index].value === selectedHeadingCategory;
          return (
            <Grid key={index} size={{ xs: 12, lg: 4 }}>
              <CategoryCard
                onClick={() => setSelectedHeadingCategory(card.value)}
                isSelected={isSelected}
                Icon={card.Icon}
                label={card.label}
                disabled={disabled}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (isActivationKey(e)) {
                    e.preventDefault();
                    setSelectedHeadingCategory(card.value);
                  }
                }}
                role="button"
              />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};
